const TENANT = {
    AD: 'f797e736-cc74-4a7b-82b5-b7a09789eed2',
    B2C: 'a3adb5ac-14f0-4963-a852-ed30c3a8ed24'
};

export default TENANT;